import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import HelpIcon from '@mui/icons-material/Help'
import './HelpTooltip.scss'

/**
 * @typedef {Object} HelpTooltipProps
 * @property {string|JSX.Element} message Translated help message
 */

/**
 * Help tooltip button.
 * @param {HelpTooltipProps} props
 * @return {JSX.Element}
 */
function HelpTooltip({ message }) {
  return (
    <Tooltip title={message}>
      <IconButton className="help-tooltip">
        <HelpIcon />
      </IconButton>
    </Tooltip>
  )
}

export default HelpTooltip
